"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The spec defines the operations that will be invoked at various times and gives sources the ability to implement
 * their own handlers in for those moments.
 *
 * Currently the only events handled are ELEMENT_MOVE_MULTI events of connected targets (handleConnectedElementMove)
 * and connecting sources (handleConnectionSourceMove).
 * These are invoked via the elementConnectionsMiddleware.
 */
exports.default = function (customSpec, initialProps) {
    var ElementConnectionSourceSpec = function ElementConnectionSourceSpec(props) {
        _classCallCheck(this, ElementConnectionSourceSpec);

        _initialiseProps.call(this);

        this.props = props;
    }

    /**
     * Private method that can receive the source's props when they change.
     */


    /**
     * Invoked when an element that a source is connected to is moved.
     * This gives sources the ability to perform some checks and updates when an element they're connected to
     * is moved.
     *
     * @param action {Object} The action object that is being dispatched.
     * @param move {Object} An object describing the move event { id, from, location }.
     */


    /**
     * Invoked when a source is moved.
     * This gives sources the ability to perform some checks and updates when it's being moved (e.g. so it can
     * disconnect if required).
     *
     * @param action {Object} The action object that is being dispatched.
     * @param move {Object} An object describing the move event { id, from, location }.
     */
    ;

    var _initialiseProps = function _initialiseProps() {
        var _this = this;

        this.receiveProps = function (props) {
            _this.props = props;
        };

        this.handleConnectedElementMove = function (action, move) {
            return customSpec.handleConnectedElementMove && customSpec.handleConnectedElementMove(_this.props, action, move);
        };

        this.handleConnectionSourceMove = function (action, move) {
            return customSpec.handleConnectionSourceMove && customSpec.handleConnectionSourceMove(_this.props, action, move);
        };
    };

    return new ElementConnectionSourceSpec(initialProps);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/createElementConnectionsSourceSpec.js
// module id = 1711
// module chunks = 0